// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"eeb3f530","273":"e09eaa63","356":"00dfd64e","424":"ab0919ef","488":"7213179a","593":"3dcce815","766":"d50f9e8a","803":"f8cebafb","989":"aae12532"}[chunkId] + ".chunk.js";
};